import { Modal } from 'antd'

type BasExistsModalProps = {
  open: boolean
  existingCompanyUser: string
  onClose: () => void
}

export default function BasExistsModal({ open, existingCompanyUser, onClose }: BasExistsModalProps) {
  return (
    <Modal
      open={open}
      onOk={onClose}
      onCancel={onClose}
      cancelButtonProps={{ style: { display: 'none' } }}
      okText="Close"
    >
      <p>
        Looks like your company is already set up!
        <br />
        It was registered by {existingCompanyUser || 'another user'} - please contact them to add you to the app.
      </p>
    </Modal>
  )
}
